"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _styles = _interopRequireDefault(require("./styles.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Instructions = /*#__PURE__*/function (_React$Component) {
  _inherits(Instructions, _React$Component);
  function Instructions(props, context) {
    var _this;
    _classCallCheck(this, Instructions);
    _this = _callSuper(this, Instructions, [props, context]);
    _this.state = {
      file: undefined,
      fileColumns: [],
      fileError: '',
      mapping: {},
      isSubmitting: false
    };
    _this.clearFile = _this.clearFile.bind(_assertThisInitialized(_this));
    _this.downloadDynamicCsv = _this.downloadDynamicCsv.bind(_assertThisInitialized(_this));
    _this.onFileDrop = _this.onFileDrop.bind(_assertThisInitialized(_this));
    _this.renderColumnWarnings = _this.renderColumnWarnings.bind(_assertThisInitialized(_this));
    _this.renderFileMatchColumn = _this.renderFileMatchColumn.bind(_assertThisInitialized(_this));
    _this.renderValidateButton = _this.renderValidateButton.bind(_assertThisInitialized(_this));
    _this.submitForValidation = _this.submitForValidation.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Instructions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        columns = _this$props.columns,
        description = _this$props.description;
      var fileUploader = this._fileUploader();

      // Define columns and data for table
      var _columns = [{
        name: 'definedColumn',
        label: 'Defined Columns',
        render: function render(value, row, callbacks) {
          // If this column is required, display an asterisk
          return row.column + (row.required ? '*' : '');
        }
      }, {
        name: 'fileMatchColumn',
        label: 'Column from File',
        render: this.renderFileMatchColumn
      }, {
        name: 'description',
        label: 'Description'
      }];
      var row = {};
      var _data = columns.filter(function (column) {
        if ({}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI) {
          return false;
        }
        return true;
      }).map(function (column) {
        row = {};
        row.column = column.name;
        row.description = column.description ? column.description : '';
        row.required = !!column.required;
        return row;
      });
      var columnWarnings = this.renderColumnWarnings();
      var validateButton = this.renderValidateButton();
      return /*#__PURE__*/_react["default"].createElement("div", null, description && /*#__PURE__*/_react["default"].createElement("p", null, description), fileUploader, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default",
        onClick: this.downloadDynamicCsv,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-download-alt"
      }), "\xA0\xA0Download Template"), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        className: "table table-striped",
        columns: _columns,
        data: _data,
        hideShowingRowsSummary: true,
        rowKey: "column",
        showPerPageOptions: columns.length > 50
      }), columnWarnings, validateButton);
    }

    // BOUND METHODS //////////////////////////////////////////////////////////

    /**
     * Clear the uploaded file and any file columns we parsed from it.
     */
  }, {
    key: "clearFile",
    value: function clearFile() {
      this.setState({
        file: undefined,
        fileColumns: [],
        mapping: {}
      });
    }

    /**
     * Dynamically create a CSV file from the columns prop and initiate its
     * download.
     */
  }, {
    key: "downloadDynamicCsv",
    value: function downloadDynamicCsv() {
      var _this$props2 = this.props,
        bulkType = _this$props2.bulkType,
        columns = _this$props2.columns;
      var columnHeaders = columns.filter(function (column) {
        if ({}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI) {
          return false;
        }
        return true;
      }).map(function (column) {
        return column.name;
      }).join(',');
      var csvContent = columnHeaders + '\r\n';
      var fileName = "example_bulk_".concat(bulkType, ".csv");
      var blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var url = URL.createObjectURL(blob);

        // Create link with appropriate properties
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    /**
     * Associate the selected column with the pre-defined bulk upload column.
     * @param {string} column The name of the pre-defined bulk upload column
     * @param {Object} event The event causing this to fire
     */
  }, {
    key: "mapFileColumnToColumn",
    value: function mapFileColumnToColumn(column, event) {
      // Map the target column to the pre-defined bulk upload column
      this.setState({
        mapping: _objectSpread(_objectSpread({}, this.state.mapping), {}, _defineProperty({}, column, parseInt(event.target.value, 10)))
      });
    }

    /**
     * Handle a drop event from Dropzone.
     *
     * @param {Object[]} accepted The files that meet the Dropzone's criteria
     * @param {Object[]} rejected The files that do not meet the Dropzone's criteria
     */
  }, {
    key: "onFileDrop",
    value: function onFileDrop(accepted, rejected) {
      if (!accepted.length) return;
      var file = accepted[0];
      var reader = new FileReader();
      var $this = this;
      reader.onload = function (event) {
        var text = event.target.result;
        var fileError = '';

        /* if file is not utf-8 encoded, it parses unknown characters
         *   as �
         *   https://discourse.algolia.com/t/csv-import-with-accented-letters/9480
         */
        if (text.includes('�')) {
          fileError = 'Unable to parse file due to an unexpected character. ' + 'Please make sure this file is exported using UTF-8 file format.';
        }
        var matches = text.match(/^(.+?)(?:\r\n|\r|\n)/);
        var fileColumns = matches[1].split(',');
        // Add a placeholder for columns without a match
        fileColumns.unshift('-- select --');

        // Create mapping for any matching columns
        var mapping = {};
        var comparableColumn = '';
        var comparableFileColumn = '';
        $this.props.columns.forEach(function (column) {
          column = column.name;
          comparableColumn = Instructions._comparableString(column);
          fileColumns.forEach(function (fileColumn, index) {
            comparableFileColumn = Instructions._comparableString(fileColumn);
            if (comparableColumn === comparableFileColumn && mapping[column] === undefined) {
              mapping[column] = index;
            }
          });
        });
        $this.setState({
          file: file,
          fileColumns: fileColumns,
          fileError: fileError,
          mapping: mapping
        });
      };
      reader.readAsText(file);
    }

    /**
     * Show enabled or disabled validate button, depending on state.
     * @return {Object|null}
     */
  }, {
    key: "renderColumnWarnings",
    value: function renderColumnWarnings() {
      var _this2 = this;
      var _this$state = this.state,
        file = _this$state.file,
        fileError = _this$state.fileError;

      // If we don't have a file, we're all done here
      if (!file) return null;
      var errorIcon = /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true",
        className: "glyphicon glyphicon-warning-sign text-danger"
      });
      var warnIcon = /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true",
        className: "glyphicon glyphicon-warning-sign text-warning"
      });
      if (fileError) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger"
        }, /*#__PURE__*/_react["default"].createElement("p", null, errorIcon, " ", fileError));
      }
      var mapping;
      var ignored = [];
      var required = [];
      this.props.columns.forEach(function (column) {
        mapping = _this2.state.mapping[column.name];
        var hidden = {}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI;
        if (!column.required && !mapping && !hidden) {
          ignored.push(column.name);
        } else if (column.required && !mapping) {
          required.push(column.name);
        }
      });
      var renderedIgnored = ignored.length === 0 ? null : /*#__PURE__*/_react["default"].createElement("div", null, warnIcon, " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-warning"
      }, "Ignored: "), ignored.join(', '));
      var renderedRequired = required.length === 0 ? null : /*#__PURE__*/_react["default"].createElement("div", null, errorIcon, " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger"
      }, "Unmapped, Required: "), required.join(', '));
      if (renderedIgnored || renderedRequired) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "well ".concat(_styles["default"].columnWarnings)
        }, renderedRequired, renderedIgnored);
      }
      return null;
    }

    /**
     * Used in Table to handle displaying and matching file columns.
     * @param {*} value The value from the data
     * @param {Object} row The row object
     * @param {Object} callbacks An object with callback functions that can be
     *     called when rendering columns and in rowActions
     */
  }, {
    key: "renderFileMatchColumn",
    value: function renderFileMatchColumn(value, row, callbacks) {
      // If we don't have any parsed file columns, we're done here
      if (!(this.state.fileColumns.length > 0)) {
        return '';
      }

      // Let's see if we have a mapping already
      var mapping = this.state.mapping[row.column];
      var defaultValue = mapping ? mapping : undefined;

      // Is this a required field?
      var selectClass = 'form-control';
      if (row.required && defaultValue === undefined) {
        // Indicate that this required field is not yet mapped
        selectClass += ' text-danger';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: selectClass,
        defaultValue: defaultValue,
        onChange: this.mapFileColumnToColumn.bind(this, row.column)
      }, this.state.fileColumns.map(function (fileColumn, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: index
        }, fileColumn);
      })));
    }

    /**
     * Show enabled or disabled validate button, depending on state.
     * @return {Object}
     */
  }, {
    key: "renderValidateButton",
    value: function renderValidateButton() {
      var buttonText = 'Validate';
      var column;
      var disabled = false;
      var hasMapping = false;
      var mapping;
      for (var i = 0; i < this.props.columns.length; i++) {
        column = this.props.columns[i];
        mapping = this.state.mapping[column.name];
        if (mapping) {
          hasMapping = true;
        }
        if (column.required && !mapping) {
          disabled = true;
          break;
        }
      }

      // We cannot allow preflight if there are no mapped columns!
      if (!disabled && !hasMapping || this.state.fileError) {
        disabled = true;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn pull-right btn-primary ".concat(_styles["default"].validate),
        disabled: disabled || this.state.isSubmitting,
        onClick: disabled || this.state.isSubmitting ? function () {} : this.submitForValidation,
        type: "button"
      }, buttonText));
    }

    /**
     * Handle submitting data to back end for validation.
     */
  }, {
    key: "submitForValidation",
    value: (function () {
      var _submitForValidation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.state.isSubmitting) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.setState({
                isSubmitting: true
              });
            case 4:
              _context.next = 6;
              return this.props.acceptValidatedFile(this.state.file, this._outputMapping());
            case 6:
              _context.next = 8;
              return this.setState({
                isSubmitting: false
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function submitForValidation() {
        return _submitForValidation.apply(this, arguments);
      }
      return submitForValidation;
    }() // HELPER METHODS /////////////////////////////////////////////////////////
    /**
     * Alter the string in preparation for comparison; lowercases, then removes
     * underscores, spaces, and hyphens.
     * @param {string} original The input string
     * @return {string}
     */
    )
  }, {
    key: "_fileUploader",
    value:
    /**
     * Render the file uploader or, if a file has already been uploaded, a
     * button to remove the file.
     * @return {Object}
     */
    function _fileUploader() {
      if (this.state.file) {
        return (
          /*#__PURE__*/
          // Button to remove the uploaded file (presumably to replace it)
          _react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-default ".concat(_styles["default"].removeFile),
            onClick: this.clearFile,
            type: "button"
          }, "Remove ", /*#__PURE__*/_react["default"].createElement("span", {
            className: "text-primary"
          }, this.state.file.name)))
        );
      }
      return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        accept: ".csv,text/csv,text/plain,application/csv,application/vnd.ms-excel",
        type: "file",
        className: _styles["default"].dropzone,
        disablePreview: true,
        multiple: false,
        onDrop: this.onFileDrop
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _styles["default"].dropzoneDescription
      }, "Drag and drop your file here (click to browse)."));
    }

    /**
     * Remove unmapped columns and re-establish 0 indexing.
     * @return {Object}
     */
  }, {
    key: "_outputMapping",
    value: function _outputMapping() {
      var outputMapping = Object.assign({}, this.state.mapping);
      Object.keys(outputMapping).forEach(function (key) {
        if (outputMapping[key] === undefined || outputMapping[key] === 0) {
          delete outputMapping[key];
        } else {
          outputMapping[key] -= 1;
        }
      });
      return outputMapping;
    }
  }], [{
    key: "_comparableString",
    value: function _comparableString(original) {
      return original.toLowerCase().replace(/[_ -]/g, '');
    }
  }]);
  return Instructions;
}(_react["default"].Component);
_defineProperty(Instructions, "propTypes", {
  /** Send validated file to parent. */
  acceptValidatedFile: _propTypes["default"].func.isRequired,
  /** Indicates what is being bulk uploaded (plural form); part of example csv name. */
  bulkType: _propTypes["default"].string,
  /** Clear validated file from parent. */
  clearValidatedFile: _propTypes["default"].func.isRequired,
  /** Definition of columns included in bulk upload file. */
  columns: _propTypes["default"].array,
  /** The description displayed at top of modal. */
  description: _propTypes["default"].string
});
_defineProperty(Instructions, "defaultProps", {
  bulkType: 'data',
  columns: [],
  description: ''
});
var _default = exports["default"] = Instructions;